import type { FC } from "react";

import classNames from "classnames";

import { StatefulDropdown } from "app/components/dashboard/widget-wizard/components/StatefulDropdown";
import I18n from "pro-features/components/WithTranslation/src/I18n";

import type { IFilterItem } from "./types";

interface IGenericDropdownFilter {
    titleKey: string;
    items: IFilterItem[];
    selectedId: string;
    onSelect?: (value: IFilterItem) => void;
    filterContainerClass?: string;
    disabled?: boolean;
}

export const GenericDropdownFilter: FC<IGenericDropdownFilter> = ({
    titleKey,
    items,
    selectedId,
    onSelect,
    filterContainerClass,
    disabled = false,
}) => {
    const dynamiFilterClassNames = classNames(filterContainerClass, "dynamicFilter");
    return (
        <div
            key={titleKey}
            className={dynamiFilterClassNames}
        >
            <h5>
                <I18n>{`home.dashboards.wizard.filters.${titleKey}`}</I18n>
            </h5>
            <StatefulDropdown
                key={`${titleKey}Filter`}
                items={items}
                selectedId={selectedId}
                onSelect={onSelect}
                disabled={disabled}
            />
        </div>
    );
};
